<template>
    <div>
        <calendar-app
            :eventos="eventos"
            @clicked="openModalCadastro"
            @event-clicked="visualizar"
            @update="updateData"
        />
        <ModalCadastrar :data="dataSelected" @store="cadastrar" />
        <ModalShow :evento="eventoSelected" />
    </div>
</template>
<script>
import ModalCadastrar from "./Add";
import ModalShow from "./Show";
export default {
    name: "Read",
    components: { ModalCadastrar, ModalShow },
    data() {
        return {
            eventos: [
                {
                    id: 1,
                    title: "Teste",
                    start: "2022-05-24",
                    end: "2022-05-28"
                },
                {
                    id: 2,
                    title: "Teste2",
                    start: "2022-05-26",
                    end: "2022-05-26"
                },
                {
                    id: 3,
                    title: "Teste2",
                    start: "2022-05-26",
                    end: "2022-05-26"
                },
                {
                    id: 4,
                    title: "Teste2",
                    start: "2022-05-26",
                    end: "2022-05-26"
                }
            ],
            dataSelected: "",
            eventoSelected: ""
        };
    },
    mounted() {},
    methods: {
        cadastrar(data) {
            //console.log(data);
            let dados = {
                id: this.eventos.length + 1,
                title: data.title,
                start: this.dataSelected.startStr
                    ? this.dataSelected.startStr
                    : this.dataSelected.dateStr,
                end: this.dataSelected.endStr
            };
            this.eventos.push(dados);
            this.$bvModal.hide("modal-cadastrar-evento");
        },
        openModalCadastro(data) {
            this.dataSelected = data;
            this.$bvModal.show("modal-cadastrar-evento");
        },
        visualizar(event) {
            this.eventoSelected = event;
            this.$bvModal.show("modal-show-evento");
        },
        updateData(event) {
            let event_id = event.event.id;
            let newDataStart = event.event.startStr;
            let newDataEnd = event.event.endStr;
            //console.log(event_id);
            //console.log(newDataStart);
            //console.log(newDataEnd);
            //console.log(event);
            this.eventos.find(
                event => event.id == event_id
            ).start = newDataStart;
            if (newDataEnd) {
                this.eventos.find(
                    event => event.id == event_id
                ).end = newDataEnd;
            }
        }
    }
};
</script>
<style></style>
